import { useState, useEffect } from "react";
import {
  SelectWithSearch,
  SaveButton,
  trans,
  CancelButton,
  ModalComponent,
  AddNewButton,
  InputText,
  InputTextArea,
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const } from "../constants";
import { Button, Checkbox, Form, Switch, message, Skeleton, Row, Col } from 'antd';
import { getRelatedDataReq, createDataReq } from "./requests";
import { createSelectList } from '@comps/commonFunctions';
import { DeleteOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import CreateTaxStrutcture from "../settings/taxStructures/components/CreateTaxStructure";
import CreatePayitem from "../settings/payitem/components/CreatePayitem";
import CreateFormula from "../settings/formula/components/CreateFormula";

const langKey = Const["payroll"].lngKey;
const formName = "createAttendanceRequest";

const CreatePayroll = (props) => {
  const [form] = Form.useForm()
  const [loader, setLoader] = useState(false);
  const [payitems, setPayitems] = useState([]);
  const [taxStructures, setTaxStructures] = useState([]);
  const [processAtMonthEnd, setProcessAtMonthEnd] = useState(false);
  const [isFixDays, setIsFixedDays] = useState(false);
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(true)
  const [childComponent, setChildComponent] = useState(null)

  useEffect(() => {
    getRelatedData();
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    setLoading(true);
    makeRequest(setLoader, getRelatedDataReq, null, onGetRelatedDataSuccess, onGetRelatedDataError);
  }
  const onGetRelatedDataSuccess = (response) => {
    setPayitems(createSelectList(response.payitems))
    setTaxStructures(createSelectList(response.tax_structures))
    setLoading(false)
  };

  const onGetRelatedDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onSubmit = (data) => {
    setSaving(true)
    const payload = {
      payroll: {
        ...data,
        company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1,
        is_fixed_days: isFixDays ? true : false,
        process_at_month_end: processAtMonthEnd,
        no_of_fixed_days: isFixDays ? data.no_of_fixed_days : null,
        processing_date: !processAtMonthEnd ? data.processing_date : null,
      }
    }
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }
  const onSuccess = (data, res) => {
    message.success("Saved successfully");
    props.onCompleted(data.payrolls.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setSaving(false)

    message.error(res.response.data.message);
  }

  const onTaxStructureCreated = (data) => {
    if (data.length) {
      form.setFieldValue('tax_structure_id', data[0].id)
      setTaxStructures(createSelectList(data))
    }
    setChildComponent(null);
  };

  const onCreatePayitem = () => {
    setChildComponent(<CreatePayitem onCompleted={ onPayitemCreated } allData={ {} } onSuccess={ onPayitemCreated } />);
  }

  const onCreateFormula = () => {
    setChildComponent(<CreateFormula onCompleted={ onFormulaCreated } onSuccess={ onFormulaCreated } />);
  }

  const onPayitemCreated = (data) => {

    if (data && data.length > 0) {
      let obj = { label: data[0].name, value: data[0].id }
      setPayitems(prev => [...prev, obj]);
      setPayitems(createSelectList(data));
    }
    setChildComponent(null)
  }

  const onFormulaCreated = () => {
    setChildComponent(null)
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  return (
    <>
      <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false }
        mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
        visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
        { childComponent }
        <Skeleton loading={ loading }>
          <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } scrollToFirstError>
            <Row gutter={ 30 }>
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="name" rules={ rules.name } label={ trans(`${langKey}.name`) }
                  className="da-mb-16"

                >
                  <InputText placeholder={ trans(`${langKey}.name`) } />
                </Form.Item>
              </Col>

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <AddNewButton onClick={ () => setChildComponent(<CreateTaxStrutcture onCompleted={ onTaxStructureCreated } />) } />
                <Form.Item name="tax_structure_id" rules={ rules.tax_structure_id } label={ trans(`${langKey}.tax_structure_id`) }
                  className="da-mb-16"

                >
                  <SelectWithSearch
                    options={ taxStructures }
                    placeholder={ trans(`${langKey}.tax_structure_id`) }
                  />
                </Form.Item>
              </Col>
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="is_tax_applicable" rules={ rules.is_tax_applicable } label={ trans(`${langKey}.is_tax_applicable`) }
                  className="da-mb-16"
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
              </Col>
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="process_at_month_end" rules={ rules.process_at_month_end } label={ trans(`${langKey}.process_at_month_end`) }
                  className="da-mb-16"
                  valuePropName="checked"
                >
                  <label>{ trans(`${langKey}.processing_date`) }</label>
                  <Switch style={ { margin: 10 } } onChange={ (value) => setProcessAtMonthEnd(value) } />
                  <label>{ trans(`${langKey}.at_end`) }</label>
                </Form.Item>
              </Col>

              {
                !processAtMonthEnd ?
                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="processing_date" rules={ rules.processing_date } label={ trans(`${langKey}.processing_date`) }
                      className="da-mb-16"

                    >
                      <InputText placeholder={ trans(`${langKey}.processing_date`) } type="number" onWheel={ (e) => e.target.blur() } />
                    </Form.Item>
                  </Col>
                  : ''
              }

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="is_fixed_days" rules={ rules.is_fixed_days } label={ trans(`${langKey}.is_fixed_days`) }
                  className="da-mb-16"
                  valuePropName="checked"
                >
                  <label>{ trans(`${langKey}.actual`) }</label>
                  <Switch style={ { margin: 10 } } onChange={ (value) => setIsFixedDays(value) } />
                  <label>{ trans(`${langKey}.fixed`) }</label>

                </Form.Item>
              </Col>

              { isFixDays ?
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="no_of_fixed_days" rules={ rules.no_of_fixed_days } label={ trans(`${langKey}.no_of_fixed_days`) }
                    className="da-mb-16"

                  >
                    <InputText placeholder={ trans(`${langKey}.no_of_fixed_dayse`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
                : '' }

              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="description" rules={ rules.description } label={ trans(`${langKey}.description`) }
                  className="da-mb-16"

                >
                  <InputTextArea placeholder={ trans(`${langKey}.description`) } />
                </Form.Item>
              </Col>
            </Row>

            <div style={ { display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 16 } }>
              <Button type="default" onClick={ onCreateFormula }>Add Formula</Button>
              <Button type="default" onClick={ onCreatePayitem }>Add Payitem</Button>
              <ReloadOutlined onClick={ getRelatedData } className="ms-2" />
            </div>
            <div className="formlist-container">
              <h5 className="formlist-title">{ trans(`${langKey}.payitems`) }</h5>
              <Form.List name="payitems" >
                { (fields, { add, remove }) => (
                  <>

                    <div className="table-container">
                      <table className="table">
                        {
                          fields.length !== 0 && <thead>
                            <tr>
                              <th style={ { paddingLeft: 20 } }>{ trans(`${langKey}.payitem_id`) }</th>
                              <th>{ trans(`${langKey}.is_taxable`) }</th>
                              <th>{ trans(`${langKey}.arrear_applicable`) }</th>
                              <th>{ trans(`${langKey}.is_final_settlement`) }</th>
                              <th>{ trans(Commons.actions) }</th>
                            </tr>
                          </thead>
                        }
                        <tbody>
                          { fields.map(({ key, name, ...restField }) => (
                            <>
                              <tr>
                                <td style={ { minWidth: '200px', paddingLeft: 20 } }>

                                  <Form.Item
                                    { ...restField }
                                    name={ [name, 'payitem_id'] }
                                    rules={ rules.payitem_id }
                                  >
                                    <SelectWithSearch
                                      options={ payitems }
                                      placeholder={ trans(`${langKey}.payitem_id`) } />
                                  </Form.Item>
                                </td>
                                <td style={ { minWidth: '200px' } }>
                                  <Form.Item
                                    { ...restField }
                                    name={ [name, 'is_taxable'] }
                                    rules={ rules.is_taxable }
                                  >
                                    <Checkbox className="formlist-remove" />
                                  </Form.Item>
                                </td>
                                <td style={ { minWidth: '200px' } }>
                                  <Form.Item
                                    { ...restField }
                                    name={ [name, 'arrear_applicable'] }
                                    rules={ rules.arrear_applicable }
                                  >
                                    <Checkbox className="formlist-remove" />
                                  </Form.Item>
                                </td>
                                <td style={ { minWidth: '200px' } }>
                                  <Form.Item
                                    { ...restField }
                                    name={ [name, 'is_final_settlement'] }
                                    rules={ rules.is_final_settlement }
                                  >
                                    <Checkbox className="formlist-remove" />
                                  </Form.Item>
                                </td>
                                <td>
                                  <DeleteOutlined className="formlist-remove" onClick={ () => {
                                    remove(name)
                                  } } />
                                </td>
                              </tr>
                            </>
                          )) }
                        </tbody>
                      </table>
                      <div className="text-center" style={ { float: 'left', marginTop: '50px', marginLeft: '5px' } }>
                        <Button onClick={ () => {
                          add()
                          // setRows(fields.length, 'Added')
                        } } icon={ <PlusOutlined /> } type="primary" className="add-node-button">Add </Button>
                      </div>
                    </div>
                  </>
                ) }
              </Form.List>
            </div>
          </Form>
        </Skeleton>
      </ModalComponent>
    </>
  )
}

export default CreatePayroll

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name`) },
  ],
  payitem_id: [
    { required: true, message: trans(`${langKey}.payitem_id`) },
  ],
  tax_structure_id: [
    { required: false, message: trans(`${langKey}.tax_structure_id`) },
  ],
  processing_date: [
    { required: true, message: trans(`${langKey}.processing_date`) },
  ],
  no_of_fixed_days: [
    { required: true, message: trans(`${langKey}.no_of_fixed_days`) },
  ],
  is_flat: [
    { required: true, message: trans(`${langKey}.is_flat`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
